import { CSSProperties, HTMLAttributes, ReactNode } from "react";

import styles from "./Icon.module.css";

export type IconType =
  | "add"
  | "advanced"
  | "arrow"
  | "arrow-left"
  | "arrow-nested"
  | "arrow-right"
  | "bug"
  | "cancel"
  | "case-sensitive"
  | "chart"
  | "chevron-down"
  | "chevron-right"
  | "check"
  | "checked-rounded"
  | "close"
  | "collapse"
  | "comment"
  | "comments"
  | "conditional"
  | "confirm"
  | "console"
  | "continue-to-next"
  | "continue-to-previous"
  | "copy"
  | "delete"
  | "discord"
  | "document"
  | "dots"
  | "down"
  | "eager-evaluation"
  | "edit"
  | "error"
  | "expand"
  | "fast-forward"
  | "file"
  | "filter"
  | "folder"
  | "folder-closed"
  | "folder-open"
  | "hide"
  | "inspect"
  | "invoke-getter"
  | "log-point-panel-arrow-above"
  | "log-point-panel-arrow-below"
  | "menu-closed"
  | "menu-open"
  | "open"
  | "open-editors"
  | "pause"
  | "play"
  | "play-processed"
  | "play-unprocessed"
  | "preview"
  | "print"
  | "prompt"
  | "protocol"
  | "protocol-viewer"
  | "radio-selected"
  | "radio-unselected"
  | "react"
  | "remove"
  | "remove-alternate"
  | "report-problem"
  | "rewind"
  | "save"
  | "screenshot"
  | "search"
  | "settings-off"
  | "set-focus-end"
  | "set-focus-start"
  | "share"
  | "source-explorer"
  | "step-one"
  | "step-two"
  | "step-three"
  | "step-four"
  | "spinner"
  | "submit-ticket"
  | "terminal-prompt"
  | "terminal-result"
  | "toggle-off"
  | "toggle-on"
  | "unchecked-rounded"
  | "up"
  | "view-component-source"
  | "view-function-source"
  | "view-html-element"
  | "visibility-private"
  | "visibility-public"
  | "visibility-team"
  | "warning"
  | "whole-word"
  | "regex";

export default function Icon({
  className = styles.DefaultIcon,
  style,
  type,
  ...rest
}: {
  className?: string;
  type: IconType;
  style?: CSSProperties;
} & HTMLAttributes<SVGElement>) {
  let path: ReactNode = null;
  switch (type) {
    case "add":
      path = "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z";
      break;
    case "advanced":
      path =
        "M14,12l-2,2l-2-2l2-2L14,12z M12,6l2.12,2.12l2.5-2.5L12,1L7.38,5.62l2.5,2.5L12,6z M6,12l2.12-2.12l-2.5-2.5L1,12 l4.62,4.62l2.5-2.5L6,12z M18,12l-2.12,2.12l2.5,2.5L23,12l-4.62-4.62l-2.5,2.5L18,12z M12,18l-2.12-2.12l-2.5,2.5L12,23l4.62-4.62 l-2.5-2.5L12,18z";
      break;
    case "arrow":
      path = "M8 5v14l11-7z";
      break;
    case "arrow-left":
      path =
        "M6.61041 11.2132L10.8896 8.20603L15.1689 5.19883C15.3545 5.06852 15.565 4.99995 15.7792 5C15.9935 5.00005 16.2039 5.06872 16.3895 5.19911C16.575 5.3295 16.7291 5.51703 16.8363 5.74285C16.9435 5.96868 16.9999 6.22484 17 6.48563V18.5143C16.9999 18.7751 16.9435 19.0313 16.8363 19.2571C16.7292 19.4829 16.5751 19.6705 16.3895 19.8009C16.204 19.9313 15.9935 19.9999 15.7792 20C15.565 20.0001 15.3545 19.9315 15.1689 19.8012L10.8896 16.794L6.61041 13.7868C6.42482 13.6564 6.27071 13.4689 6.16356 13.243C6.05641 13.0171 6 12.7609 6 12.5C6 12.2392 6.05641 11.983 6.16356 11.7571C6.27071 11.5312 6.42482 11.3436 6.61041 11.2132Z";
      break;
    case "arrow-nested":
      path =
        "M20 16L14.5 21.5L13.08 20.09L16.17 17H10.5C6.91 17 4 14.09 4 10.5V4H6V10.5C6 13 8 15 10.5 15H16.17L13.09 11.91L14.5 10.5L20 16Z";
      break;
    case "arrow-right":
      path =
        "M17.3896 12.7868L13.1104 15.794L8.83113 18.8012C8.64554 18.9315 8.43505 19 8.22079 19C8.00654 19 7.79606 18.9313 7.61051 18.8009C7.42496 18.6705 7.27087 18.483 7.1637 18.2571C7.05654 18.0313 7.00008 17.7752 7 17.5144L7 5.48569C7.00007 5.2249 7.05653 4.96872 7.16368 4.74289C7.27084 4.51706 7.42494 4.32952 7.61049 4.19912C7.79604 4.06872 8.00652 4.00005 8.22078 4C8.43504 3.99995 8.64554 4.06852 8.83113 4.19883L13.1104 7.20603L17.3896 10.2132C17.5752 10.3436 17.7293 10.5311 17.8364 10.757C17.9436 10.9829 18 11.2391 18 11.5C18 11.7608 17.9436 12.017 17.8364 12.2429C17.7293 12.4688 17.5752 12.6564 17.3896 12.7868Z";
      break;
    case "bug":
      path =
        "M21.29 16.71L22.71 15.29L19.5 12.11L16.5 11.26L18.41 11L22.6 7.8L21.4 6.2L17.59 9.05L14.91 9.5L18.11 6.31L17 1.76L15 2.24L15.86 5.69L14.76 6.83A3 3 0 0 0 9.24 6.83L8.11 5.69L9 2.24L7 1.76L5.89 6.31L9.09 9.5L6.4 9.05L2.6 6.2L1.4 7.8L5.6 11L7.46 11.31L4.46 12.16L1.29 15.29L2.71 16.71L5.5 13.89L7.87 13.22L4 16.54V22H6V17.46L7.56 16.12A4.5 4.5 0 0 0 16.44 16.12L18 17.46V22H20V16.54L16.13 13.22L18.5 13.89Z";
      break;
    case "cancel":
      path =
        "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z";
      break;
    case "case-sensitive":
      path =
        "m 10.337711,15.322735 1.665105,4.391691 h 2.038866 L 7.9867548,4.0127288 H 6.0805741 L 0.06862948,19.714426 H 2.1149706 L 3.6810289,15.322735 Z M 7.190644,6.728102 7.2728714,6.9803907 9.7359559,13.659498 H 4.282784 L 6.7253116,6.9803907 6.807539,6.728102 6.8785536,6.4365685 6.9383553,6.1525102 6.9776002,5.9170408 h 0.042982 l 0.044851,0.2354694 0.054195,0.2840583 z m 14.920537,11.233385 v 1.749201 h 1.794052 v -7.292076 c 0,-1.34367 -0.336385,-2.377119 -1.007286,-3.1040843 -0.670901,-0.726965 -1.661367,-1.0895131 -2.967662,-1.0895131 -0.371892,0 -0.74939,0.035507 -1.132495,0.104653 a 9.1104228,9.1104228 0 0 0 -2.014572,0.6092304 3.8889825,3.8889825 0 0 0 -0.641,0.3513352 v 1.8389038 c 0.497102,-0.429825 1.057744,-0.768079 1.6894,-1.009154 A 5.4699913,5.4699913 0 0 1 19.7976,9.7593032 c 0.351336,0 0.669032,0.052326 0.958697,0.1588484 a 1.8314286,1.8314286 0 0 1 0.740047,0.4989714 c 0.203699,0.226125 0.360679,0.521396 0.470939,0.882075 0.110259,0.360679 0.164454,0.79798 0.164454,1.308163 L 18.747332,13.0783 c -0.642869,0.08783 -1.196035,0.23547 -1.659498,0.442907 a 3.6385627,3.6385627 0 0 0 -1.149315,0.783029 2.9900875,2.9900875 0 0 0 -0.67277,1.083907 3.9880292,3.9880292 0 0 0 -0.21865,1.347408 c 0,0.459726 0.07849,0.887682 0.231732,1.285737 0.153242,0.398056 0.379367,0.741916 0.678376,1.029712 0.299008,0.287796 0.672769,0.51579 1.117545,0.683982 0.444775,0.168193 0.958697,0.252289 1.543633,0.252289 0.751259,0 1.420291,-0.17193 2.008965,-0.519528 0.588673,-0.347597 1.068956,-0.848437 1.440848,-1.506256 z M 18.134364,14.70416 c 0.32891,-0.119603 0.749391,-0.213044 1.259575,-0.278452 l 2.737798,-0.383105 v 1.138102 c 0,0.459726 -0.07662,0.887683 -0.229863,1.285738 a 3.2274257,3.2274257 0 0 1 -0.641,1.040924 2.9396298,2.9396298 0 0 1 -0.979253,0.695196 3.0461516,3.0461516 0 0 1 -1.248362,0.252288 c -0.349466,0 -0.659688,-0.04672 -0.925058,-0.142029 a 1.9248688,1.9248688 0 0 1 -0.667163,-0.394318 1.674449,1.674449 0 0 1 -0.411137,-0.590542 1.8781487,1.8781487 0 0 1 -0.14203,-0.73444 2.9900875,2.9900875 0 0 1 0.102785,-0.822274 1.3810467,1.3810467 0 0 1 0.377498,-0.624181 2.1678134,2.1678134 0 0 1 0.76621,-0.442907 z";
      break;
    case "chart":
      path =
        "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9 17H7V10H9V17M13 17H11V7H13V17M17 17H15V13H17V17Z";
      break;
    case "chevron-down":
      path = "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z";
      break;
    case "chevron-right":
      path = "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z";
      break;
    case "close":
      path =
        "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z";
      break;
    case "check":
      path = (
        <>
          <path
            d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
          />
        </>
      );
      break;
    case "checked-rounded":
      path = (
        <>
          <path
            d="M12 22C13.366 22 14.6503 21.7386 15.8529 21.2157C17.0621 20.6928 18.1274 19.9706 19.049 19.049C19.9706 18.1275 20.6928 17.0654 21.2157 15.8627C21.7386 14.6536 22 13.366 22 12C22 10.634 21.7386 9.34967 21.2157 8.14707C20.6928 6.93792 19.9706 5.87256 19.049 4.95098C18.1274 4.02942 17.0621 3.30719 15.8529 2.78432C14.6438 2.26144 13.3562 2 11.9902 2C10.6242 2 9.3366 2.26144 8.12745 2.78432C6.92484 3.30719 5.86273 4.02942 4.94118 4.95098C4.02614 5.87256 3.3072 6.93792 2.78431 8.14707C2.26144 9.34967 2 10.634 2 12C2 13.366 2.26144 14.6536 2.78431 15.8627C3.3072 17.0654 4.02942 18.1275 4.95097 19.049C5.87255 19.9706 6.93463 20.6928 8.13726 21.2157C9.34641 21.7386 10.634 22 12 22ZM12 20.3333C10.8431 20.3333 9.76143 20.1177 8.7549 19.6863C7.74837 19.2549 6.86275 18.6601 6.09803 17.902C5.33987 17.1373 4.7451 16.2516 4.31373 15.2451C3.88889 14.2386 3.67646 13.1569 3.67646 12C3.67646 10.8431 3.88889 9.76144 4.31373 8.75491C4.7451 7.74837 5.33987 6.86274 6.09803 6.09804C6.85622 5.33334 7.73857 4.73857 8.74511 4.31373C9.75164 3.88236 10.8333 3.66667 11.9902 3.66667C13.1471 3.66667 14.2288 3.88236 15.2353 4.31373C16.2484 4.73857 17.134 5.33334 17.8922 6.09804C18.6569 6.86274 19.2549 7.74837 19.6863 8.75491C20.1176 9.76144 20.3333 10.8431 20.3333 12C20.3333 13.1569 20.1176 14.2386 19.6863 15.2451C19.2614 16.2516 18.6667 17.1373 17.902 17.902C17.1373 18.6601 16.2516 19.2549 15.2451 19.6863C14.2386 20.1177 13.1569 20.3333 12 20.3333ZM10.9216 16.6471C11.2549 16.6471 11.5196 16.4967 11.7157 16.1961L16.1961 9.13727C16.2549 9.04575 16.3072 8.94773 16.3529 8.84314C16.4052 8.73204 16.4314 8.62092 16.4314 8.50982C16.4314 8.29413 16.3497 8.12092 16.1863 7.99021C16.0229 7.85948 15.8399 7.79413 15.6373 7.79413C15.3628 7.79413 15.134 7.94117 14.951 8.2353L10.8823 14.7647L8.95098 12.2647C8.83334 12.1079 8.71568 12.0033 8.59804 11.951C8.48692 11.8922 8.36275 11.8628 8.2255 11.8628C8.01635 11.8628 7.8366 11.9412 7.68628 12.098C7.54247 12.2484 7.47059 12.4314 7.47059 12.6471C7.47059 12.8497 7.54575 13.0523 7.69607 13.2549L10.0882 16.1961C10.2124 16.3529 10.3399 16.4673 10.4706 16.5392C10.6078 16.6111 10.7582 16.6471 10.9216 16.6471Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case "collapse":
      path =
        "M19.5,3.09L15,7.59V4H13V11H20V9H16.41L20.91,4.5L19.5,3.09M4,13V15H7.59L3.09,19.5L4.5,20.91L9,16.41V20H11V13H4Z";
      break;
    case "comment":
      path =
        "M7.4342 22C7.64309 22 7.83706 21.951 8.01611 21.8531C8.20113 21.7552 8.41898 21.5931 8.66965 21.3667L12.0537 18.2735L17.6132 18.2827C18.5264 18.2827 19.3113 18.1022 19.9678 17.7412C20.6243 17.374 21.1256 16.8539 21.4718 16.1808C21.8239 15.5077 22 14.7061 22 13.776V6.50665C22 5.57656 21.8239 4.77497 21.4718 4.10188C21.1256 3.42879 20.6243 2.91173 19.9678 2.55071C19.3113 2.18357 18.5264 2 17.6132 2H6.38675C5.47359 2 4.68875 2.18357 4.03223 2.55071C3.38168 2.91173 2.88033 3.42879 2.5282 4.10188C2.17607 4.77497 2 5.57656 2 6.50665V13.776C2 14.7061 2.17905 15.5077 2.53715 16.1808C2.90122 16.8539 3.39958 17.371 4.03223 17.732C4.67084 18.093 5.40495 18.2735 6.23456 18.2735H6.48523V20.9169C6.48523 21.2474 6.56879 21.5105 6.7359 21.7063C6.90898 21.9021 7.14175 22 7.4342 22ZM7.6222 10.1413C7.6222 9.82316 7.72068 9.5631 7.91764 9.36117C8.12056 9.15313 8.37123 9.04911 8.66965 9.04911H10.9615V6.6994C10.9615 6.39345 11.06 6.13951 11.2569 5.93759C11.4539 5.72954 11.7046 5.62552 12.009 5.62552C12.3133 5.62552 12.564 5.72954 12.761 5.93759C12.9639 6.13951 13.0654 6.39345 13.0654 6.6994V9.04911H15.3662C15.6646 9.04911 15.9123 9.15313 16.1092 9.36117C16.3062 9.5631 16.4047 9.82316 16.4047 10.1413C16.4047 10.4473 16.3062 10.7043 16.1092 10.9123C15.9123 11.1143 15.6646 11.2152 15.3662 11.2152H13.0654V13.5649C13.0654 13.8709 12.9639 14.1248 12.761 14.3268C12.564 14.5287 12.3133 14.6296 12.009 14.6296C11.7046 14.6296 11.4539 14.5287 11.2569 14.3268C11.06 14.1248 10.9615 13.8709 10.9615 13.5649V11.2152H8.66965C8.37123 11.2152 8.12056 11.1143 7.91764 10.9123C7.72068 10.7043 7.6222 10.4473 7.6222 10.1413Z";
      break;
    case "comments":
      path =
        "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z";
      break;
    case "conditional":
      path = (
        <>
          <g opacity={0.5}>
            <path
              clipRule="evenodd"
              d="M1.5 5.69013C1.5 6.33298 2.02113 6.85411 2.66398 6.85411L16.6317 6.85411C17.2746 6.85411 17.7957 6.33298 17.7957 5.69013C17.7957 5.04728 17.2746 4.52615 16.6317 4.52615L2.66398 4.52615C2.02113 4.52615 1.5 5.04728 1.5 5.69013Z"
              fill="currentColor"
              fillRule="evenodd"
            ></path>
            <path
              d="M21.8705 6.69786C22.6464 6.24984 22.6464 5.1298 21.8705 4.68179L16.6326 1.65769C15.8566 1.20967 14.8866 1.76969 14.8866 2.66572L14.8866 8.71392C14.8866 9.60996 15.8566 10.17 16.6326 9.72196L21.8705 6.69786Z"
              fill="currentColor"
            ></path>
          </g>
          <path
            clipRule="evenodd"
            d="M1.5 5.69015C1.5 6.333 2.02113 6.85413 2.66398 6.85413C4.155 6.85413 6.16581 6.87659 7.81772 7.85549C9.34116 8.75827 10.8118 10.6448 10.8118 15.002C10.8118 15.6448 11.333 16.166 11.9758 16.166C12.6186 16.166 13.1398 15.6448 13.1398 15.002C13.1398 10.0474 11.4095 7.27795 9.00451 5.85277C6.76418 4.52516 4.16689 4.52581 2.73256 4.52617C2.70939 4.52617 2.68653 4.52618 2.66398 4.52618C2.02113 4.52618 1.5 5.04731 1.5 5.69015Z"
            fill="currentColor"
            fillRule="evenodd"
          ></path>
          <path
            d="M11.4944 22.316C11.7083 22.6863 12.2428 22.6863 12.4566 22.316L16.5346 15.2527C16.7484 14.8823 16.4812 14.4194 16.0535 14.4194L7.89751 14.4194C7.46989 14.4194 7.20262 14.8823 7.41644 15.2527L11.4944 22.316Z"
            fill="currentColor"
          ></path>
        </>
      );
      break;
    case "confirm":
      path = "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z";
      break;
    case "console":
      path =
        "M6.48242 8.4209H13.918C14.0762 8.4209 14.2051 8.36816 14.3047 8.2627C14.4102 8.15723 14.4629 8.02832 14.4629 7.87598C14.4629 7.72363 14.4102 7.59766 14.3047 7.49805C14.2051 7.39258 14.0762 7.33984 13.918 7.33984H6.48242C6.32422 7.33984 6.19238 7.39258 6.08691 7.49805C5.9873 7.59766 5.9375 7.72363 5.9375 7.87598C5.9375 8.02832 5.9873 8.15723 6.08691 8.2627C6.19238 8.36816 6.32422 8.4209 6.48242 8.4209ZM6.48242 16.8145H13.918C14.0762 16.8145 14.2051 16.7646 14.3047 16.665C14.4102 16.5654 14.4629 16.4395 14.4629 16.2871C14.4629 16.1289 14.4102 15.9971 14.3047 15.8916C14.2051 15.7861 14.0762 15.7334 13.918 15.7334H6.48242C6.32422 15.7334 6.19238 15.7861 6.08691 15.8916C5.9873 15.9971 5.9375 16.1289 5.9375 16.2871C5.9375 16.4395 5.9873 16.5654 6.08691 16.665C6.19238 16.7646 6.32422 16.8145 6.48242 16.8145ZM4.75977 20.1807H19.9648C20.8906 20.1807 21.582 19.9521 22.0391 19.4951C22.4961 19.0439 22.7246 18.3643 22.7246 17.4561V6.72461C22.7246 5.81641 22.4961 5.13672 22.0391 4.68555C21.582 4.22852 20.8906 4 19.9648 4H4.75977C3.83984 4 3.14844 4.22852 2.68555 4.68555C2.22852 5.13672 2 5.81641 2 6.72461V17.4561C2 18.3643 2.22852 19.0439 2.68555 19.4951C3.14844 19.9521 3.83984 20.1807 4.75977 20.1807ZM4.77734 18.7656C4.33789 18.7656 4.00098 18.6514 3.7666 18.4229C3.53223 18.1885 3.41504 17.8428 3.41504 17.3857V6.79492C3.41504 6.33789 3.53223 5.99512 3.7666 5.7666C4.00098 5.53223 4.33789 5.41504 4.77734 5.41504H19.9473C20.3809 5.41504 20.7148 5.53223 20.9492 5.7666C21.1895 5.99512 21.3096 6.33789 21.3096 6.79492V17.3857C21.3096 17.8428 21.1895 18.1885 20.9492 18.4229C20.7148 18.6514 20.3809 18.7656 19.9473 18.7656H4.77734ZM5.7002 14.1514H19.0332C19.3965 14.1514 19.6807 14.0459 19.8857 13.835C20.0908 13.6182 20.1934 13.3281 20.1934 12.9648V11.1807C20.1934 10.8174 20.0908 10.5303 19.8857 10.3193C19.6807 10.1025 19.3965 9.99414 19.0332 9.99414H5.7002C5.33691 9.99414 5.05273 10.1025 4.84766 10.3193C4.64258 10.5303 4.54004 10.8174 4.54004 11.1807V12.9648C4.54004 13.3281 4.64258 13.6182 4.84766 13.835C5.05273 14.0459 5.33691 14.1514 5.7002 14.1514ZM6.49121 12.6221C6.32715 12.6221 6.19238 12.5693 6.08691 12.4639C5.9873 12.3584 5.9375 12.2266 5.9375 12.0684C5.9375 11.9219 5.9873 11.7988 6.08691 11.6992C6.19238 11.5938 6.32715 11.541 6.49121 11.541H10.8154C10.9736 11.541 11.1025 11.5938 11.2021 11.6992C11.3076 11.7988 11.3604 11.9219 11.3604 12.0684C11.3604 12.2266 11.3076 12.3584 11.2021 12.4639C11.1025 12.5693 10.9736 12.6221 10.8154 12.6221H6.49121Z";
      break;
    case "continue-to-next":
      path = "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z";
      break;
    case "continue-to-previous":
      path = "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z";
      break;
    case "copy":
      path =
        "M11.0572 20.5417V9.70833H14.4172V13.5774C14.4172 14.0045 14.7935 14.3512 15.2572 14.3512H19.4572V20.5417H11.0572ZM9.34286 11.125V14.125H4.71429V3.625H7.8V7.375C7.8 7.789 8.1456 8.125 8.57143 8.125H12.4286C10.7253 8.125 9.34286 9.469 9.34286 11.125ZM13.0115 7.00083H9.25718V3.35083L13.0115 7.00083ZM19.2857 13H15.8571V9.66668L19.2857 13ZM20.6233 12.3662L16.7661 8.61625C16.5257 8.38125 16.1991 8.25 15.8571 8.25H14.5714V7C14.5714 6.66875 14.4364 6.35 14.1947 6.11625L10.3376 2.36625C10.0971 2.13125 9.76929 2 9.42857 2H5.57143C4.152 2 3 3.12 3 4.5V13.25C3 14.63 4.152 15.75 5.57143 15.75H9.42857V19.5C9.42857 20.88 10.5806 22 12 22H18.4286C19.848 22 21 20.88 21 19.5V13.25C21 12.9187 20.865 12.6 20.6233 12.3662Z";
      break;
    case "delete":
      path = "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z";
      break;
    case "discord":
      path =
        "M18.942 6.25622C17.6279 5.66091 16.2407 5.23856 14.8158 5C14.6208 5.34493 14.4444 5.69983 14.2872 6.06319C12.7694 5.83686 11.2258 5.83686 9.70801 6.06319C9.55081 5.69986 9.37438 5.34497 9.17946 5C7.75361 5.24059 6.36551 5.66392 5.05016 6.25934C2.43887 10.0825 1.73099 13.8107 2.08493 17.4859C3.61417 18.6041 5.32583 19.4544 7.14549 20C7.55523 19.4547 7.91779 18.8761 8.22933 18.2705C7.63759 18.0519 7.06646 17.782 6.52256 17.4642C6.6657 17.3614 6.80571 17.2556 6.941 17.1529C8.52364 17.8894 10.251 18.2713 12 18.2713C13.7489 18.2713 15.4763 17.8894 17.059 17.1529C17.1958 17.2634 17.3358 17.3693 17.4774 17.4642C16.9324 17.7826 16.3603 18.0528 15.7675 18.2721C16.0786 18.8774 16.4412 19.4555 16.8513 20C18.6725 19.4565 20.3855 18.6066 21.915 17.4875C22.3303 13.2254 21.2056 9.53143 18.942 6.25622ZM8.67766 15.2257C7.69134 15.2257 6.87649 14.3399 6.87649 13.2503C6.87649 12.1606 7.66303 11.2671 8.67451 11.2671C9.68599 11.2671 10.4946 12.1606 10.4772 13.2503C10.4599 14.3399 9.68284 15.2257 8.67766 15.2257ZM15.3223 15.2257C14.3344 15.2257 13.5227 14.3399 13.5227 13.2503C13.5227 12.1606 14.3092 11.2671 15.3223 11.2671C16.3354 11.2671 17.1376 12.1606 17.1203 13.2503C17.103 14.3399 16.3275 15.2257 15.3223 15.2257Z";
      break;
    case "document":
      path =
        "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z";
      break;
    case "dots":
      path =
        "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z";
      break;
    case "down":
      path = "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z";
      break;
    case "eager-evaluation":
      path = "M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z";
      break;
    case "edit":
      path =
        "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z";
      break;
    case "error":
      path =
        "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z";
      break;
    case "expand":
      path =
        "M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z";
      break;
    case "fast-forward":
      path =
        "M19.5012 3C18.6769 3 18.0025 3.675 18.0025 4.5V19.5C18.0025 20.325 18.6769 21 19.5012 21C20.3256 21 21 20.325 21 19.5V4.5C21 3.675 20.3256 3 19.5012 3ZM14.0158 13.23L5.36805 19.335C4.3788 20.04 3 19.32 3 18.105V5.895C3 4.68 4.3638 3.975 5.36805 4.665L14.0158 10.77C14.8701 11.37 14.8701 12.63 14.0158 13.23Z";
      break;
    case "file":
      path =
        "M6 22q-.825 0-1.412-.587Q4 20.825 4 20V4q0-.825.588-1.413Q5.175 2 6 2h8l6 6v12q0 .825-.587 1.413Q18.825 22 18 22Zm7-13V4H6v16h12V9ZM6 4v5-5 16V4Z";
      break;
    case "filter":
      path =
        "M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z";
      break;
    case "folder":
    case "folder-closed":
      path =
        "M20,18H4V8H20M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z";
      break;
    case "folder-open":
      path =
        "M6.1,10L4,18V8H21A2,2 0 0,0 19,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H19C19.9,20 20.7,19.4 20.9,18.5L23.2,10H6.1M19,18H6L7.6,12H20.6L19,18Z";
      break;
    case "hide":
      path =
        "M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z";
      break;
    case "inspect":
      path = (
        <>
          <path d="M 4.5 4.5 C 3.671875 4.5 3 5.171875 3 6 L 3 18 C 3 18.828125 3.671875 19.5 4.5 19.5 L 8.398438 19.5 C 9.226562 19.5 9.898438 20.171875 9.898438 21 C 9.898438 21.828125 9.226562 22.5 8.398438 22.5 L 4.5 22.5 C 2.015625 22.5 0 20.484375 0 18 L 0 6 C 0 3.515625 2.015625 1.5 4.5 1.5 L 19.5 1.5 C 21.984375 1.5 24 3.515625 24 6 L 24 9.898438 C 24 10.726562 23.328125 11.398438 22.5 11.398438 C 21.671875 11.398438 21 10.726562 21 9.898438 L 21 6 C 21 5.171875 20.328125 4.5 19.5 4.5 Z M 4.5 4.5 "></path>
          <path d="M 19.304688 21.898438 C 19.753906 22.441406 20.578125 22.5 21.105469 22.050781 C 21.644531 21.585938 21.703125 20.761719 21.253906 20.21875 L 18.523438 17.023438 L 22.15625 15.523438 C 22.328125 15.460938 22.449219 15.296875 22.449219 15.109375 C 22.453125 14.925781 22.34375 14.753906 22.171875 14.683594 L 11.144531 9.644531 C 10.984375 9.566406 10.796875 9.589844 10.660156 9.703125 C 10.523438 9.816406 10.46875 10 10.515625 10.171875 L 13.710938 22.003906 C 13.757812 22.179688 13.90625 22.308594 14.085938 22.332031 C 14.269531 22.355469 14.445312 22.269531 14.535156 22.109375 L 16.558594 18.691406 Z M 19.304688 21.898438 "></path>
        </>
      );
      break;
    case "invoke-getter":
      path = (
        <>
          <polygon points="6.41,6 5,7.41 9.58,12 5,16.59 6.41,18 12.41,12" />
          <polygon points="13,6 11.59,7.41 16.17,12 11.59,16.59 13,18 19,12" />
        </>
      );
      break;
    case "log-point-panel-arrow-above":
      path =
        "M11 17.17L12.59 15.58L14 17L10 21L6 17L7.41 15.59L9 17.17L9 9C9 7.9 9.9 7 11 7L20 7L20 9L11 9L11 17.17Z";
      break;
    case "log-point-panel-arrow-below":
      path =
        "M11 6.83L12.59 8.42L14 7L10 3L6 7L7.41 8.41L9 6.83L9 15C9 16.1 9.9 17 11 17L20 17L20 15L11 15L11 6.83Z";
      break;
    case "menu-closed":
      path = "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z";
      break;
    case "menu-open":
      path =
        "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z";
      break;
    case "open":
      path =
        "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z";
      break;
    case "open-editors":
      path = (
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(.04637 0 0 .04637 .1295 .12988)">
          <path d="m405.33 287.98h-64c-11.782 0-21.333 9.551-21.333 21.333s9.551 21.333 21.333 21.333h64c11.782 0 21.333-9.551 21.333-21.333s-9.551-21.333-21.333-21.333zm0-85.334h-64c-11.782 0-21.333 9.551-21.333 21.333s9.551 21.333 21.333 21.333h64c11.782 0 21.333-9.551 21.333-21.333 0-11.781-9.551-21.333-21.333-21.333zm-85.333-64c0 11.782 9.551 21.333 21.333 21.333h64c11.782 0 21.333-9.551 21.333-21.333s-9.551-21.333-21.333-21.333h-64c-11.782 0-21.333 9.551-21.333 21.333zm-149.33 149.33h-64c-11.782 0-21.333 9.551-21.333 21.333s9.551 21.333 21.333 21.333h64c11.782 0 21.333-9.551 21.333-21.333 1e-3 -11.782-9.551-21.333-21.333-21.333zm0-85.334h-64c-11.782 0-21.333 9.551-21.333 21.333s9.551 21.333 21.333 21.333h64c11.782 0 21.333-9.551 21.333-21.333 1e-3 -11.781-9.551-21.333-21.333-21.333zm0-85.333h-64c-11.782 0-21.333 9.551-21.333 21.333s9.551 21.333 21.333 21.333h64c11.782 0 21.333-9.551 21.333-21.333 1e-3 -11.782-9.551-21.333-21.333-21.333zm320-106.67h-161.84c-25.891 0-54.101 14.916-72.828 35.943-18.726-21.027-46.937-35.943-72.828-35.943h-161.83c-11.782 0-21.333 9.552-21.333 21.334v405.33c0 11.782 9.551 21.333 21.333 21.333h159.68c25.518 5.325 40.9 12.882 51.739 26.428l5.429 6.781c1.306 1.949 2.917 3.632 4.744 5.018 3.922 3.109 8.525 4.508 13.072 4.466 4.547 0.042 9.15-1.357 13.072-4.466 1.827-1.386 3.439-3.069 4.744-5.018l5.426-6.778c10.842-13.549 26.223-21.106 51.742-26.431h159.68c11.782 0 21.333-9.551 21.333-21.333v-405.33c-1e-3 -11.782-9.552-21.334-21.334-21.334zm-303.31 405.75-4.184-0.414h-140.5v-362.67h140.5c21.522 0 51.164 24.973 51.484 42.38 1e-3 0.092 6e-3 0.19 6e-3 0.28v3e-3 4e-3 336.22c-13.241-7.152-28.764-12.095-47.306-15.803zm281.97-0.414h-140.5l-4.184 0.414c-18.542 3.708-34.065 8.651-47.306 15.803v-336.22-4e-3 -3e-3c0-0.09 5e-3 -0.188 6e-3 -0.28 0.32-17.407 29.961-42.38 51.484-42.38h140.5v362.67z" />
        </g>
      );
      break;
    case "pause":
      path =
        "M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M11,16H9V8h2V16z M15,16h-2V8h2V16z";
      break;
    case "play":
      path =
        "M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82z";
      break;
    case "play-processed":
      path = (
        <>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="currentColor" />
            <path
              d="M16.569 11.2599C17.1437 11.5864 17.1437 12.4134 16.569 12.7401L9.27488 16.8872C8.70631 17.2105 8 16.8003 8 16.1471V7.85296C8 7.1996 8.70631 6.78954 9.27488 7.1128L16.569 11.2599Z"
              fill="white"
            />
          </svg>
        </>
      );
      break;
    case "play-unprocessed":
      path = (
        <>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
            <path
              d="M16.569 11.2599C17.1437 11.5864 17.1437 12.4134 16.569 12.7401L9.27488 16.8872C8.70631 17.2105 8 16.8003 8 16.1471V7.85296C8 7.1996 8.70631 6.78954 9.27488 7.1128L16.569 11.2599Z"
              fill="currentColor"
            />
          </svg>
        </>
      );
      break;
    case "preview":
      path =
        "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z";
      break;
    case "print":
      path =
        "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z";
      break;
    case "prompt":
      path = (
        <>
          <polygon points="6.41,6 5,7.41 9.58,12 5,16.59 6.41,18 12.41,12" />
          <polygon points="13,6 11.59,7.41 16.17,12 11.59,16.59 13,18 19,12" />
        </>
      );
      break;
    case "protocol":
      path =
        "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z";
      break;
    case "protocol-viewer":
      path =
        "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z";
      break;
    case "radio-selected":
      path =
        "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z";
      break;
    case "radio-unselected":
      path =
        "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z";
      break;
    case "react":
      path = (
        <>
          <path
            d="M17.3073 20.4763C19.1626 19.4051 18.4266 14.6567 15.6633 9.87057C12.9 5.08439 9.15582 2.07279 7.30047 3.14398C5.44512 4.21517 6.18116 8.9635 8.94447 13.7497C11.7078 18.5358 15.4519 21.5474 17.3073 20.4763Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.30057 20.4762C9.15592 21.5474 12.9001 18.5358 15.6633 13.7496C18.4266 8.96344 19.1627 4.21511 17.3073 3.14392C15.452 2.07274 11.7078 5.08433 8.94453 9.8705C6.18125 14.6567 5.44522 19.405 7.30057 20.4762Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.3106 11.8101C22.3106 9.66778 17.8304 7.93104 12.3038 7.93103C6.77724 7.93102 2.29706 9.66775 2.29706 11.8101C2.29706 13.9525 6.77724 15.6892 12.3038 15.6892C17.8304 15.6892 22.3106 13.9525 22.3106 11.8101Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.2348 13.1466C12.9435 13.1466 13.518 12.572 13.518 11.8633C13.518 11.1546 12.9435 10.5801 12.2348 10.5801C11.5261 10.5801 10.9516 11.1546 10.9516 11.8633C10.9516 12.572 11.5261 13.1466 12.2348 13.1466Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="0.1"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      );
      break;
    case "remove":
      path = "M19 13H5v-2h14v2z";
      break;
    case "remove-alternate":
      path =
        "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z";
      break;
    case "report-problem":
      path =
        "M2.73 21h18.53c.77 0 1.25-.83.87-1.5l-9.27-16c-.39-.67-1.35-.67-1.73 0l-9.27 16c-.38.67.1 1.5.87 1.5zM13 18h-2v-2h2v2zm-1-4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z";
      break;
    case "rewind":
      path =
        "M4.49875 3C5.32306 3 5.9975 3.675 5.9975 4.5V19.5C5.9975 20.325 5.32306 21 4.49875 21C3.67444 21 3 20.325 3 19.5V4.5C3 3.675 3.67444 3 4.49875 3ZM9.98418 13.23L18.6319 19.335C19.6212 20.04 21 19.32 21 18.105V5.895C21 4.68 19.6362 3.975 18.6319 4.665L9.98418 10.77C9.12988 11.37 9.12988 12.63 9.98418 13.23Z";
      break;
    case "save":
      path =
        "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z";
      break;
    case "screenshot":
      path =
        "M3 4V1H5V4H8V6H5V9H3V6H0V4M6 10V7H9V4H16L17.8 6H21C22.1 6 23 6.9 23 8V20C23 21.1 22.1 22 21 22H5C3.9 22 3 21.1 3 20V10M13 19C17.45 19 19.69 13.62 16.54 10.46C13.39 7.31 8 9.55 8 14C8 16.76 10.24 19 13 19M9.8 14C9.8 16.85 13.25 18.28 15.26 16.26C17.28 14.25 15.85 10.8 13 10.8C11.24 10.8 9.8 12.24 9.8 14Z";
      break;
    case "search":
      path =
        "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z";
      break;
    case "settings-off":
      path = (
        <>
          <defs>
            <clipPath id="settingsOffClipPath4">
              <rect
                x="10.267"
                y="13.445"
                width="7.0339"
                height="1.3559"
                d="m 10.266949,13.444917 h 7.033899 v 1.355932 h -7.033899 z"
                display="none"
              />
              <path d="m4.1525 4.4915h19.263v19.263h-19.263zm6.1144 8.9534v1.3559h7.0339v-1.3559z" />
            </clipPath>
            <clipPath id="settingsOffClipPath5">
              <circle
                cx="13.766"
                cy="14.123"
                r="4.7924"
                d="M 18.558061,14.122882 A 4.7923727,4.7923727 0 0 1 13.765688,18.915255 4.7923727,4.7923727 0 0 1 8.9733152,14.122882 4.7923727,4.7923727 0 0 1 13.765688,9.3305092 4.7923727,4.7923727 0 0 1 18.558061,14.122882 Z"
                display="none"
                fill="currentColor"
              />
              <path
                d="m-3.4844-3.1172h26.969v26.953h-26.969zm22.042 17.24a4.7924 4.7924 0 0 0-4.7924-4.7924 4.7924 4.7924 0 0 0-4.7924 4.7924 4.7924 4.7924 0 0 0 4.7924 4.7924 4.7924 4.7924 0 0 0 4.7924-4.7924z"
                fill="currentColor"
              />
            </clipPath>
          </defs>
          <path
            transform="matrix(1.3502 0 0 1.3502 -1.1048 -1.6417)"
            d="m18.415 14.123a4.6314 4.6314 0 0 1-4.6314 4.6314 4.6314 4.6314 0 0 1-4.6314-4.6314 4.6314 4.6314 0 0 1 4.6314-4.6314 4.6314 4.6314 0 0 1 4.6314 4.6314z"
            clipPath="url(#settingsOffClipPath4)"
            fill="currentColor"
          />
          <path
            transform="matrix(1.4015 0 0 1.4015 -1.9306 -2.4848)"
            d="m9.2109 18.836h1.586c0.3229 0 0.6015-0.0911 0.8359-0.2734s0.388-0.4297 0.461-0.7422l0.3203-1.3828 0.2031-0.0703 1.2031 0.7344c0.2708 0.1718 0.5547 0.2369 0.8516 0.1953 0.3021-0.0365 0.5677-0.1693 0.7969-0.3985l1.0937-1.0859c0.2292-0.2344 0.362-0.5 0.3984-0.7969 0.0417-0.2968-0.0234-0.5807-0.1953-0.8515l-0.75-1.1953 0.0782-0.1954 1.375-0.3203c0.3072-0.0781 0.552-0.2343 0.7343-0.4687 0.1875-0.2396 0.2813-0.5183 0.2813-0.836v-1.539c0-0.31771-0.0938-0.59636-0.2813-0.83594-0.1823-0.23959-0.4271-0.39584-0.7343-0.46875l-1.3594-0.32813-0.086-0.21094 0.75-1.1953c0.1719-0.26562 0.237-0.54687 0.1954-0.84375-0.0365-0.29687-0.1693-0.5625-0.3985-0.79687l-1.0937-1.0938c-0.224-0.22917-0.487-0.36198-0.7891-0.39844-0.2969-0.04167-0.5807 0.02083-0.8516 0.1875l-1.2031 0.74219-0.2187-0.08594-0.3203-1.3828c-0.073-0.30729-0.2266-0.55209-0.461-0.73438-0.2344-0.1875-0.513-0.28125-0.8359-0.28125h-1.586c-0.32292 0-0.60417 0.09375-0.84375 0.28125-0.23438 0.18229-0.38802 0.42709-0.46094 0.73438l-0.32031 1.3828-0.21875 0.08594-1.2031-0.74219c-0.27083-0.16667-0.55468-0.22917-0.85156-0.1875-0.29688 0.03646-0.5599 0.16927-0.78906 0.39844l-1.0938 1.0938c-0.23438 0.23437-0.36979 0.5-0.40625 0.79687-0.03646 0.29688 0.03125 0.57813 0.20312 0.84375l0.75 1.1953-0.07812 0.21094-1.3672 0.32813c-0.3125 0.07812-0.5599 0.23698-0.74219 0.47656-0.18229 0.23437-0.27344 0.51042-0.27344 0.82813v1.539c0 0.3177 0.09115 0.5964 0.27344 0.836 0.1875 0.2396 0.4349 0.3958 0.74219 0.4687l1.3828 0.3203 0.07032 0.1954-0.75 1.1953c-0.17188 0.2708-0.23959 0.5547-0.20313 0.8515 0.03646 0.2969 0.17187 0.5625 0.40625 0.7969l1.0938 1.0859c0.22917 0.2292 0.49219 0.362 0.78906 0.3985 0.30209 0.0416 0.58854-0.0235 0.85938-0.1953l1.1953-0.7344 0.21094 0.0703 0.32031 1.3828c0.07292 0.3125 0.22656 0.5599 0.46094 0.7422 0.23958 0.1823 0.52083 0.2734 0.84375 0.2734zm0.19531-1.414c-0.13021 0-0.20573-0.0599-0.22656-0.1797l-0.46094-1.9219c-0.24479-0.0573-0.48437-0.1328-0.71875-0.2265-0.22917-0.099-0.4401-0.2084-0.63281-0.3282l-1.6875 1.0391c-0.09375 0.0625-0.1875 0.0495-0.28125-0.0391l-0.83594-0.8281c-0.07812-0.0781-0.08594-0.1719-0.02344-0.2813l1.0391-1.6796c-0.10416-0.1927-0.20572-0.4011-0.30468-0.625-0.09896-0.2292-0.17969-0.4688-0.24219-0.7188l-1.9219-0.4531c-0.1198-0.0208-0.17969-0.0938-0.17969-0.2188v-1.1718c0-0.11979 0.05989-0.19271 0.17969-0.21875l1.9219-0.46093c0.05729-0.26042 0.13802-0.50782 0.24219-0.74219 0.10416-0.23438 0.20052-0.4349 0.28906-0.60157l-1.0312-1.6797c-0.06771-0.10938-0.0599-0.20834 0.02344-0.29688l0.83593-0.82031c0.08855-0.07813 0.1849-0.08854 0.28907-0.03125l1.6797 1.0156c0.17708-0.10416 0.38541-0.20572 0.625-0.30468 0.24479-0.10417 0.49218-0.1875 0.74218-0.25l0.45313-1.9219c0.02083-0.11979 0.09635-0.17968 0.22656-0.17968h1.1954c0.125 0 0.1953 0.05989 0.2109 0.17968l0.4687 1.9375c0.2553 0.0625 0.4948 0.14323 0.7188 0.24219 0.2292 0.09375 0.4401 0.19531 0.6328 0.30469l1.6797-1.0234c0.1094-0.05729 0.2083-0.04427 0.2969 0.03906l0.8281 0.8125c0.0885 0.08854 0.0964 0.1875 0.0234 0.29688l-1.0312 1.6797c0.0937 0.16667 0.1901 0.36719 0.2891 0.60157 0.1041 0.23437 0.1874 0.48177 0.25 0.74219l1.9218 0.46093c0.1198 0.02604 0.1797 0.09896 0.1797 0.21875v1.1718c0 0.125-0.0599 0.198-0.1797 0.2188l-1.9297 0.4609c-0.0573 0.2448-0.1354 0.4818-0.2343 0.711-0.0938 0.2291-0.1954 0.4375-0.3047 0.625l1.0312 1.6718c0.0677 0.1146 0.0599 0.2084-0.0234 0.2813l-0.8281 0.8359c-0.0938 0.0886-0.1901 0.099-0.2891 0.0313l-1.6797-1.0313c-0.1927 0.1198-0.401 0.2292-0.625 0.3282-0.2239 0.0937-0.4661 0.1692-0.7266 0.2265l-0.4687 1.9219c-0.0156 0.1198-0.0859 0.1797-0.2109 0.1797zm0.59375-4.0938c0.5469 0 1.0443-0.1328 1.4922-0.3984s0.8047-0.625 1.0703-1.0781c0.2656-0.4532 0.3984-0.9506 0.3984-1.4922 0-0.54169-0.1328-1.0365-0.3984-1.4844s-0.6224-0.80469-1.0703-1.0703c-0.4479-0.26563-0.9453-0.39844-1.4922-0.39844-0.54167 0-1.0391 0.13281-1.4922 0.39844-0.44791 0.26562-0.80729 0.62239-1.0781 1.0703-0.26563 0.44792-0.39844 0.94271-0.39844 1.4844 0 0.5468 0.13281 1.0442 0.39844 1.4922 0.27083 0.4479 0.63021 0.8073 1.0781 1.0781 0.45313 0.2656 0.95052 0.3984 1.4922 0.3984zm0-1.3437c-0.29688 0-0.56771-0.0729-0.8125-0.2188-0.24479-0.1458-0.4401-0.3411-0.58594-0.5859-0.14583-0.2448-0.21875-0.5182-0.21875-0.8203 0-0.2969 0.07292-0.56513 0.21875-0.80471 0.14584-0.24479 0.34115-0.44011 0.58594-0.58594s0.51562-0.21875 0.8125-0.21875c0.2917 0 0.5599 0.07292 0.8047 0.21875s0.4375 0.34115 0.5781 0.58594c0.1458 0.23958 0.2188 0.50781 0.2188 0.80471 0 0.2968-0.073 0.5677-0.2188 0.8125-0.1406 0.2448-0.3333 0.4427-0.5781 0.5937-0.2448 0.1459-0.513 0.2188-0.8047 0.2188z"
            clipPath="url(#settingsOffClipPath5)"
          />
        </>
      );
      break;
    case "set-focus-end":
      path = (
        <>
          <path
            fill="currentColor"
            d="M20.0885 12.1788C19.9705 12.0987 19.9705 11.9013 20.0885 11.8212L22.7303 10.0288C22.8497 9.94777 23 10.0474 23 10.2076L23 13.7924C23 13.9526 22.8497 14.0522 22.7303 13.9712L20.0885 12.1788Z"
          />
          <path
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 7C6.89543 7 6 7.89543 6 9V15C6 16.1046 6.89543 17 8 17H16C17.1046 17 18 16.1046 18 15V9C18 7.89543 17.1046 7 16 7H8ZM15 7.71429H9V16.2857H15V7.71429Z"
          />
        </>
      );
      break;
    case "set-focus-start":
      path = (
        <>
          <path
            fill="curentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 7C6.89543 7 6 7.89543 6 9V15C6 16.1046 6.89543 17 8 17H16C17.1046 17 18 16.1046 18 15V9C18 7.89543 17.1046 7 16 7H8ZM15 7.71429H9V16.2857H15V7.71429Z"
          />
          <path
            fill="curentColor"
            d="M3.91147 11.8212C4.02951 11.9013 4.02951 12.0987 3.91147 12.1788L1.26968 13.9712C1.15029 14.0522 1 13.9526 1 13.7924V10.2076C1 10.0474 1.15029 9.94777 1.26968 10.0288L3.91147 11.8212Z"
          />
        </>
      );
      break;
    case "share":
      path =
        "M12,1L8,5H11V14H13V5H16M18,23H6C4.89,23 4,22.1 4,21V9A2,2 0 0,1 6,7H9V9H6V21H18V9H15V7H18A2,2 0 0,1 20,9V21A2,2 0 0,1 18,23Z";
      break;
    case "source-explorer":
      path =
        "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z";
      break;
    case "step-one":
      path = (
        <>
          <path
            d="M22.0073 12.0039C22.0073 17.5268 17.5302 22.0039 12.0073 22.0039C6.48448 22.0039 2.00732 17.5268 2.00732 12.0039C2.00732 6.48106 6.48448 2.00391 12.0073 2.00391C17.5302 2.00391 22.0073 6.48106 22.0073 12.0039Z"
            fill="currentColor"
          />
          <path
            d="M11.6707 14.5881V11.3596C11.6707 10.6799 11.6843 10.1545 11.7117 9.78341C11.6023 9.93575 11.405 10.1291 11.1199 10.3635L10.2117 11.0959L9.39136 10.0529L11.9343 8.03146H13.1824V14.5881H14.5769V15.9182H10.2585V14.5881H11.6707Z"
            fill="#DEE6ED"
          />
        </>
      );
      break;
    case "step-two":
      path = (
        <>
          <path
            d="M22.0073 12.0039C22.0073 17.5268 17.5302 22.0039 12.0073 22.0039C6.48448 22.0039 2.00732 17.5268 2.00732 12.0039C2.00732 6.48106 6.48448 2.00391 12.0073 2.00391C17.5302 2.00391 22.0073 6.48106 22.0073 12.0039Z"
            fill="currentColor"
          />
          <path
            d="M14.7937 15.9182H9.28589V14.7522L11.3367 12.7248C12.1023 11.967 12.5789 11.4416 12.7664 11.1486C12.9578 10.8557 13.0535 10.5529 13.0535 10.2404C13.0535 9.93966 12.9617 9.70529 12.7781 9.53732C12.5945 9.36544 12.3464 9.2795 12.0339 9.2795C11.7253 9.2795 11.4226 9.342 11.1257 9.467C10.8289 9.5881 10.491 9.79904 10.1121 10.0998L9.26245 9.03927C9.67261 8.73068 9.99878 8.50997 10.241 8.37716C10.4871 8.24044 10.7644 8.12911 11.073 8.04318C11.3816 7.95724 11.7175 7.91427 12.0808 7.91427C12.8269 7.91427 13.4265 8.1174 13.8796 8.52365C14.3367 8.9299 14.5652 9.44747 14.5652 10.0764C14.5652 10.4631 14.491 10.8303 14.3425 11.1779C14.198 11.5217 13.9734 11.8713 13.6687 12.2268C13.364 12.5783 12.8992 13.0451 12.2742 13.6272L11.3484 14.4885V14.5529H14.7937V15.9182Z"
            fill="#DEE6ED"
          />
        </>
      );
      break;

    case "step-three":
      path = (
        <>
          <path
            d="M22.0073 12.0039C22.0073 17.5268 17.5302 22.0039 12.0073 22.0039C6.48448 22.0039 2.00732 17.5268 2.00732 12.0039C2.00732 6.48106 6.48448 2.00391 12.0073 2.00391C17.5302 2.00391 22.0073 6.48106 22.0073 12.0039Z"
            fill="currentColor"
          />
          <path
            d="M12.8015 11.7639V11.8049C14.0671 11.9611 14.7 12.592 14.7 13.6975C14.7 14.424 14.4285 14.9963 13.8855 15.4143C13.3425 15.8283 12.5652 16.0354 11.5535 16.0354C10.6902 16.0354 9.93433 15.8928 9.28589 15.6076V14.2014C9.61011 14.3615 9.96167 14.4885 10.3406 14.5822C10.7234 14.6721 11.0964 14.717 11.4597 14.717C12.0339 14.717 12.4617 14.6272 12.7429 14.4475C13.0281 14.2678 13.1707 13.9904 13.1707 13.6154C13.1707 13.1975 13.0125 12.9026 12.696 12.7307C12.3796 12.5588 11.8699 12.4729 11.1667 12.4729H10.4988V11.2365H11.1316C11.7488 11.2365 12.2156 11.1565 12.532 10.9963C12.8484 10.8361 13.0066 10.5529 13.0066 10.1467C13.0066 9.85763 12.9109 9.63302 12.7195 9.47286C12.5281 9.31271 12.2312 9.23263 11.8289 9.23263C11.532 9.23263 11.241 9.2795 10.9558 9.37325C10.6707 9.4631 10.366 9.60958 10.0417 9.81271L9.29761 8.68185C10.1257 8.17013 10.9968 7.91427 11.9109 7.91427C12.7156 7.91427 13.3484 8.08419 13.8093 8.42404C14.2742 8.75997 14.5066 9.21896 14.5066 9.80099C14.5066 10.2932 14.3582 10.7111 14.0613 11.0549C13.7683 11.3947 13.3484 11.6311 12.8015 11.7639Z"
            fill="#DEE6ED"
          />
        </>
      );
      break;

    case "step-four":
      path = (
        <>
          <path
            d="M22.0073 12.0039C22.0073 17.5268 17.5302 22.0039 12.0073 22.0039C6.48448 22.0039 2.00732 17.5268 2.00732 12.0039C2.00732 6.48106 6.48448 2.00391 12.0073 2.00391C17.5302 2.00391 22.0073 6.48106 22.0073 12.0039Z"
            fill="currentColor"
          />
          <path
            d="M14.5205 14.2249H13.501V15.9182H12.0127V14.2249H8.5791V13.0881L12.0361 8.03149H13.501V12.9534H14.5205V14.2249ZM12.0127 12.9534V11.5764C12.0127 10.8147 12.0361 10.2463 12.083 9.87134H12.0479C11.8955 10.2034 11.7236 10.5159 11.5322 10.8088L10.0908 12.9534H12.0127Z"
            fill="#DEE6ED"
          />
        </>
      );
      break;

    case "spinner":
      path =
        "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z";
      break;
    case "submit-ticket":
      path =
        "M6.02885 9.59588C5.8592 9.59588 5.71785 9.53434 5.60475 9.4112C5.49732 9.28192 5.4436 9.12495 5.4436 8.94027C5.4436 8.76174 5.49732 8.61091 5.60475 8.48778C5.71785 8.36467 5.8592 8.3031 6.02885 8.3031H11.4996C11.6636 8.3031 11.8021 8.36467 11.9152 8.48778C12.0339 8.61091 12.0933 8.76174 12.0933 8.94027C12.0933 9.12495 12.0339 9.28192 11.9152 9.4112C11.8021 9.53434 11.6636 9.59588 11.4996 9.59588H6.02885ZM6.02885 12.0614C5.8592 12.0614 5.71785 11.9998 5.60475 11.8767C5.49732 11.7475 5.4436 11.5935 5.4436 11.415C5.4436 11.2365 5.49732 11.0857 5.60475 10.9626C5.71785 10.8333 5.8592 10.7686 6.02885 10.7686H10.0322C10.1962 10.7686 10.3347 10.8333 10.4478 10.9626C10.5666 11.0857 10.626 11.2365 10.626 11.415C10.626 11.5935 10.5666 11.7475 10.4478 11.8767C10.3347 11.9998 10.1962 12.0614 10.0322 12.0614H6.02885ZM16.5293 12.3107C16.1561 12.3107 15.814 12.2122 15.503 12.0152C15.1977 11.8121 14.9517 11.5443 14.7651 11.2119C14.5841 10.8733 14.4937 10.5008 14.4937 10.0945C14.4937 9.68822 14.5841 9.31886 14.7651 8.98644C14.9517 8.64784 15.1977 8.38005 15.503 8.18305C15.814 7.9799 16.1561 7.87834 16.5293 7.87834C16.9025 7.87834 17.2418 7.9799 17.5471 8.18305C17.8524 8.38005 18.0956 8.64784 18.2765 8.98644C18.4631 9.31886 18.5565 9.68822 18.5565 10.0945C18.5565 10.5008 18.4631 10.8733 18.2765 11.2119C18.0956 11.5443 17.8524 11.8121 17.5471 12.0152C17.2418 12.2122 16.9025 12.3107 16.5293 12.3107ZM4.66327 21C3.77552 21 3.10829 20.76 2.66158 20.2798C2.22053 19.8058 2 19.0947 2 18.1467V6.86258C2 5.90839 2.22053 5.19429 2.66158 4.72026C3.10829 4.24009 3.77552 4 4.66327 4H19.3367C20.2302 4 20.8973 4.24009 21.3385 4.72026C21.7795 5.20044 22 5.91454 22 6.86258V18.1467C22 19.0947 21.7795 19.8058 21.3385 20.2798C20.8973 20.76 20.2302 21 19.3367 21H4.66327ZM4.68025 19.5134H19.3198C19.7382 19.5134 20.0605 19.3933 20.2867 19.1532C20.5185 18.9069 20.6343 18.5438 20.6343 18.0636V6.94569C20.6343 6.46551 20.5185 6.10231 20.2867 5.85606C20.0605 5.60981 19.7382 5.4867 19.3198 5.4867H4.68025C4.25615 5.4867 3.93102 5.60981 3.70483 5.85606C3.47866 6.10231 3.36556 6.46551 3.36556 6.94569V18.0636C3.36556 18.5438 3.47866 18.9069 3.70483 19.1532C3.93102 19.3933 4.25615 19.5134 4.68025 19.5134Z";
      break;
    case "terminal-prompt":
      path = (
        <g>
          <polygon points="6.41,6 5,7.41 9.58,12 5,16.59 6.41,18 12.41,12" />
          <polygon points="13,6 11.59,7.41 16.17,12 11.59,16.59 13,18 19,12" />
        </g>
      );
      break;
    case "terminal-result":
      path = "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z";
      break;
    case "toggle-off":
      path =
        "m16.1 13.3-1.45-1.45q.225-1.175-.675-2.2-.9-1.025-2.325-.8L10.2 7.4q.425-.2.862-.3Q11.5 7 12 7q1.875 0 3.188 1.312Q16.5 9.625 16.5 11.5q0 .5-.1.938-.1.437-.3.862Zm3.2 3.15-1.45-1.4q.95-.725 1.688-1.588.737-.862 1.262-1.962-1.25-2.525-3.588-4.013Q14.875 6 12 6q-.725 0-1.425.1-.7.1-1.375.3L7.65 4.85q1.025-.425 2.1-.638Q10.825 4 12 4q3.775 0 6.725 2.087Q21.675 8.175 23 11.5q-.575 1.475-1.512 2.738Q20.55 15.5 19.3 16.45Zm.5 6.15-4.2-4.15q-.875.275-1.762.413Q12.95 19 12 19q-3.775 0-6.725-2.087Q2.325 14.825 1 11.5q.525-1.325 1.325-2.463Q3.125 7.9 4.15 7L1.4 4.2l1.4-1.4 18.4 18.4ZM5.55 8.4q-.725.65-1.325 1.425T3.2 11.5q1.25 2.525 3.587 4.012Q9.125 17 12 17q.5 0 .975-.062.475-.063.975-.138l-.9-.95q-.275.075-.525.112Q12.275 16 12 16q-1.875 0-3.188-1.312Q7.5 13.375 7.5 11.5q0-.275.037-.525.038-.25.113-.525Zm7.975 2.325ZM9.75 12.6Z";
      break;
    case "toggle-on":
      path =
        "M12 16q1.875 0 3.188-1.312Q16.5 13.375 16.5 11.5q0-1.875-1.312-3.188Q13.875 7 12 7q-1.875 0-3.188 1.312Q7.5 9.625 7.5 11.5q0 1.875 1.312 3.188Q10.125 16 12 16Zm0-1.8q-1.125 0-1.912-.788Q9.3 12.625 9.3 11.5t.788-1.913Q10.875 8.8 12 8.8t1.913.787q.787.788.787 1.913t-.787 1.912q-.788.788-1.913.788Zm0 4.8q-3.65 0-6.65-2.038-3-2.037-4.35-5.462 1.35-3.425 4.35-5.463Q8.35 4 12 4q3.65 0 6.65 2.037 3 2.038 4.35 5.463-1.35 3.425-4.35 5.462Q15.65 19 12 19Zm0-7.5Zm0 5.5q2.825 0 5.188-1.488Q19.55 14.025 20.8 11.5q-1.25-2.525-3.612-4.013Q14.825 6 12 6 9.175 6 6.812 7.487 4.45 8.975 3.2 11.5q1.25 2.525 3.612 4.012Q9.175 17 12 17Z";
      break;
    case "unchecked-rounded":
      path = (
        <>
          <path
            d="M12 22C13.366 22 14.6503 21.7386 15.8529 21.2157C17.0621 20.6928 18.1275 19.9706 19.049 19.049C19.9706 18.1275 20.6928 17.0654 21.2157 15.8627C21.7386 14.6536 22 13.366 22 12C22 10.634 21.7386 9.34967 21.2157 8.14707C20.6928 6.93792 19.9706 5.87256 19.049 4.95098C18.1275 4.02942 17.0621 3.30719 15.8529 2.78432C14.6438 2.26144 13.3562 2 11.9902 2C10.6242 2 9.33659 2.26144 8.12745 2.78432C6.92484 3.30719 5.86273 4.02942 4.94118 4.95098C4.02614 5.87256 3.3072 6.93792 2.78431 8.14707C2.26144 9.34967 2 10.634 2 12C2 13.366 2.26144 14.6536 2.78431 15.8627C3.3072 17.0654 4.02942 18.1275 4.95097 19.049C5.87255 19.9706 6.93463 20.6928 8.13726 21.2157C9.34641 21.7386 10.634 22 12 22ZM12 20.3333C10.8431 20.3333 9.76143 20.1177 8.7549 19.6863C7.74837 19.2549 6.86275 18.6601 6.09803 17.902C5.33987 17.1373 4.7451 16.2516 4.31373 15.2451C3.88889 14.2386 3.67646 13.1569 3.67646 12C3.67646 10.8431 3.88889 9.76144 4.31373 8.75491C4.7451 7.74837 5.33987 6.86274 6.09803 6.09804C6.85622 5.33334 7.73857 4.73857 8.74511 4.31373C9.75164 3.88236 10.8333 3.66667 11.9902 3.66667C13.1471 3.66667 14.2288 3.88236 15.2353 4.31373C16.2484 4.73857 17.134 5.33334 17.8922 6.09804C18.6569 6.86274 19.2549 7.74837 19.6863 8.75491C20.1176 9.76144 20.3333 10.8431 20.3333 12C20.3333 13.1569 20.1176 14.2386 19.6863 15.2451C19.2614 16.2516 18.6667 17.1373 17.902 17.902C17.1373 18.6601 16.2516 19.2549 15.2451 19.6863C14.2386 20.1177 13.1569 20.3333 12 20.3333Z"
            fill="currentColor"
          />
        </>
      );
      break;
    case "up":
      path = "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z";
      break;
    case "view-component-source":
      path =
        "M12.89,3L14.85,3.4L11.11,21L9.15,20.6L12.89,3M19.59,12L16,8.41V5.58L22.42,12L16,18.41V15.58L19.59,12M1.58,12L8,5.58V8.41L4.41,12L8,15.58V18.41L1.58,12Z";
      break;
    case "view-function-source":
      path = "M12.34,6V4H18v5.66h-2V7.41l-5,5V20H9v-7.58c0-0.53,0.21-1.04,0.59-1.41l5-5H12.34z";
      break;
    case "view-html-element":
      path =
        "M5.25 6.5C5.25 5.87891 5.75391 5.375 6.375 5.375H17.625C18.2461 5.375 18.75 5.87891 18.75 6.5V9.42383C18.75 10.045 19.2539 10.5488 19.875 10.5488C20.4961 10.5488 21 10.045 21 9.42383V6.5C21 4.63671 19.4883 3.125 17.625 3.125H6.375C4.51171 3.125 3 4.63671 3 6.5V15.5C3 17.3633 4.51171 18.875 6.375 18.875H9.29883C9.91992 18.875 10.4238 18.3711 10.4238 17.75C10.4238 17.1289 9.91992 16.625 9.29883 16.625H6.375C5.75391 16.625 5.25 16.1211 5.25 15.5V6.5ZM18.8291 18.5381C18.4336 18.875 17.8154 18.831 17.4785 18.4238L15.419 16.0186L13.9014 18.5821C13.834 18.7021 13.7021 18.7666 13.5644 18.749C13.4297 18.7315 13.3184 18.6348 13.2832 18.5029L10.8867 9.62892C10.8516 9.5 10.8926 9.36231 10.9952 9.27735C11.0977 9.19238 11.2383 9.17481 11.3584 9.2334L19.6289 13.0127C19.7579 13.0654 19.8398 13.1944 19.8369 13.3321C19.8369 13.4727 19.7461 13.5957 19.6172 13.6426L16.8926 14.7675L18.9404 17.1641C19.2773 17.5713 19.2334 18.1894 18.8291 18.5381Z";
      break;
    case "visibility-private":
      path =
        "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z";
      break;
    case "visibility-public":
      path =
        "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z";
      break;
    case "visibility-team":
      path = (
        <g>
          <path
            d="M16.67,13.13C18.04,14.06,19,15.32,19,17v3h4v-3 C23,14.82,19.43,13.53,16.67,13.13z"
            fillRule="evenodd"
          />
          <circle cx="9" cy="8" fillRule="evenodd" r="4" />
          <path
            d="M15,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4c-0.47,0-0.91,0.1-1.33,0.24 C14.5,5.27,15,6.58,15,8s-0.5,2.73-1.33,3.76C14.09,11.9,14.53,12,15,12z"
            fillRule="evenodd"
          />
          <path d="M9,13c-2.67,0-8,1.34-8,4v3h16v-3C17,14.34,11.67,13,9,13z" fillRule="evenodd" />
        </g>
      );
      break;
    case "warning":
      path =
        "M2.73 21h18.53c.77 0 1.25-.83.87-1.5l-9.27-16c-.39-.67-1.35-.67-1.73 0l-9.27 16c-.38.67.1 1.5.87 1.5zM13 18h-2v-2h2v2zm-1-4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z";
      break;
    case "whole-word":
      path =
        "m14.657 15.467h-0.03861v1.4282h-1.5826v-14.63h1.5826v6.4849h0.03861c0.77843-1.3124 1.9172-1.9686 3.4162-1.9686 1.2674 0 2.2581 0.44391 2.9723 1.3317 0.72047 0.88138 1.0807 2.0651 1.0807 3.5513 0 1.6534-0.4021 2.9787-1.2063 3.9759-0.8042 0.99069-1.9043 1.486-3.3003 1.486-1.306 0-2.2935-0.5532-2.9625-1.6598zm-0.03861-3.9855v1.38c0 0.81706 0.26377 1.5119 0.79131 2.0844 0.5339 0.56606 1.2095 0.84922 2.0266 0.84922 0.95853 0 1.7081-0.3667 2.2484-1.1001 0.54691-0.73341 0.82036-1.7531 0.82036-3.0591 0-1.1001-0.25423-1.9622-0.76233-2.5862-0.50828-0.62404-1.1968-0.93607-2.0653-0.93607-0.9199 0-1.6598 0.32168-2.2194 0.96502-0.55972 0.63692-0.83957 1.4379-0.83957 2.4029zm-4.4657 5.4137h-1.5826v-1.5441h-0.038612c-0.68838 1.1838-1.7016 1.7757-3.0398 1.7757-0.98433 0-1.7563-0.26052-2.316-0.78174-0.55327-0.52104-0.82991-1.2126-0.82991-2.0747 0-1.8464 1.0872-2.9208 3.2618-3.2231l2.9626-0.41496c0-1.6791-0.67873-2.5187-2.0362-2.5187-1.1902 0-2.2646 0.40531-3.2231 1.2159v-1.6212c0.97145-0.61761 2.0909-0.92642 3.3583-0.92642 2.3225 0 3.4837 1.2288 3.4837 3.6864zm-1.5826-4.9988-2.3836 0.32811c-0.73342 0.10294-1.2867 0.28628-1.6598 0.55005-0.37315 0.25734-0.55972 0.71732-0.55972 1.38 0 0.4825 0.17049 0.87816 0.51146 1.187 0.34741 0.3022 0.80739 0.45348 1.38 0.45348 0.78488 0 1.4314-0.27345 1.9397-0.82027 0.51468-0.55327 0.77202-1.2513 0.77202-2.0941zm-8.4959 5.3321h1.5021v3.0042h21.03v-3.0042h1.5021v4.5064h-24.034z";
      break;
    case "regex":
      path =
        "m 16.001615,0.15254237 h 1.934779 V 6.3236181 l 5.074833,-3.086529 0.963426,1.7543854 -5.082763,3.0904938 5.082763,3.0904937 -0.961444,1.754385 -5.076815,-3.0865285 V 16.011394 H 16.001615 V 9.8403185 L 10.926782,12.926847 9.9633569,11.172462 15.046119,8.0819683 9.9633569,4.9914745 10.9248,3.2370891 16.001615,6.3236181 Z M 0.11897458,16.011394 H 8.0484005 V 23.94082 H 0.11897458 Z";
      break;
  }

  if (typeof path === "string") {
    path = <path d={path} />;
  }

  return (
    <svg className={className} style={style} viewBox="0 0 24 24" fill="currentColor" {...rest}>
      <path d="M0 0h24v24H0z" fill="none" />
      {path}
    </svg>
  );
}
